import { render, staticRenderFns } from "./DefectData.vue?vue&type=template&id=6ed5182f&scoped=true"
import script from "./DefectData.vue?vue&type=script&lang=js"
export * from "./DefectData.vue?vue&type=script&lang=js"
import style0 from "./DefectData.vue?vue&type=style&index=0&id=6ed5182f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed5182f",
  null
  
)

export default component.exports